export class Password_request {
        
    user_id: string;
	password_changed: boolean;
	token: string;

    constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}